import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FMPHeadline from '../../components/ui/FMPHeadline';
import FMPQuickbooksAccountSelect from '../../components/pureForm/FMPQuickbooksAccountSelect';
import FMPProductSelect from '../../components/pureForm/FMPProductSelect';
import { allProducts, valueToDisplay } from '../../libs/products';
import Button from '@material-ui/core/Button';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import QuickbooksFreightAccountContainer from '../../containers/billing/QuickbooksFreightAccount';
//import FMPCheckbox from "../../components/pureForm/FMPCheckbox";
import FMPQuickbooksItemSelect from '../../components/pureForm/FMPQuickbooksItemSelect';
import QuickbooksFuelItemContainer from '../../containers/billing/QuickbooksFuelItem';

const styles = (theme) => {
	return {
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 25,
			paddingBottom: 30,
			marginTop: 10,
			[theme.breakpoints.up('md')]: {
				padding: '30px 40px 40px 40px',
			},
		},
		addButton: {
			borderRadius: '100px',
		},
		currentOptions: {
			fonSize: 20,
			lineHeight: 1.7,
		},
		infoBox: {
			padding: 30,
			backgroundColor: '#eee',
			border: '1px solid #ddd',
			borderRadius: '2px',
			fontSize: 18,
			color: '#555',
		},
	};
};

class QuickbooksMapping extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
		};
	}

	componentDidMount() {
		const {
			quickbooksFreightAccounts,
			searchQuickbooksFreightAccounts,
			quickbooksFuelItems,
			searchQuickbooksFuelItems,
		} = this.props;

		if (!quickbooksFreightAccounts) {
			searchQuickbooksFreightAccounts();
		}
		if (!quickbooksFuelItems) {
			searchQuickbooksFuelItems();
		}
	}

	handleAddFreight = () => {
		const { addQuickbooksFreightAccount, showErrors } = this.props;

		//- we do not support Updates...yet...ever?
		const { quickbooksAccountId, defaultForProductType } = this.state;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [
			{ path: 'quickbooksAccountId', display: 'QB Account' },
			{ path: 'defaultForProductType', display: 'Default for fuel type (or none)' },
		];

		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		//- Lock and load
		const params = {
			quickbooksAccountId: parseInt(quickbooksAccountId, 10),
			defaultForProductType,
		};

		addQuickbooksFreightAccount({
			params,
		});
	};

	handleAddFuelItem = () => {
		const { addQuickbooksFuelItem, showErrors } = this.props;

		//- we do not support Updates...yet...ever?
		const { quickbooksItemId, defaultForProductTypeForFuel } = this.state;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [
			{ path: 'quickbooksItemId', display: 'QB Item' },
			{ path: 'defaultForProductTypeForFuel', display: 'Default for fuel type (or none)' },
		];
		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		//- Lock and load
		const params = {
			quickbooksItemId: parseInt(quickbooksItemId, 10),
			defaultForProductType: defaultForProductTypeForFuel,
			isFuelLineItem: true,
		};

		addQuickbooksFuelItem({
			params,
		});
	};

	handleAddTaxItem = () => {
		const { addQuickbooksFuelItem, showErrors } = this.props;

		//- we do not support Updates...yet...ever?
		const { quickbooksTaxItemId } = this.state;

		//- Required fields
		const formFieldError = {};
		const errors = [];

		const _setError = (path, error) => {
			_.set(formFieldError, path, error);
			errors.push(error);
		};

		let fields = [{ path: 'quickbooksTaxItemId', display: 'QB Item' }];
		fields.forEach((s) => {
			if (!_.get(this.state, s.path)) {
				_setError(s.path, `${s.display} is required`);
			}
		});

		if (!_.isEmpty(errors)) {
			this.setState({ formFieldError });
			return showErrors(errors);
		}

		//- Lock and load
		const params = {
			quickbooksItemId: parseInt(quickbooksTaxItemId, 10),
			isFuelLineItem: false,
		};

		addQuickbooksFuelItem({
			params,
		});
	};

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}
		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			checked: this.getValue(path, false),
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const {
			classes,
			quickbooksFreightAccounts,
			quickbooksFuelItems,
			quickbooksAccountMap,
			quickbooksItemMap,
		} = this.props;

		if (!_.isEmpty(quickbooksFreightAccounts)) {
			quickbooksFreightAccounts.forEach((quickbooksFreightAccount) => {
				const { quickbooksAccountId, defaultForProductType } = quickbooksFreightAccount;
				const quickbooksAccount = quickbooksAccountMap[quickbooksAccountId] || { Name: 'Missing' };
				quickbooksFreightAccount.display = quickbooksAccount.Name;
				quickbooksFreightAccount.productDisplay = valueToDisplay(defaultForProductType);
			});
		}

		if (!_.isEmpty(quickbooksFuelItems)) {
			quickbooksFuelItems.forEach((quickbooksFuelItem) => {
				const { quickbooksItemId, defaultForProductType } = quickbooksFuelItem;
				const quickbooksItem = quickbooksItemMap[quickbooksItemId] || {
					Name: 'Missing',
					Description: '',
				};
				quickbooksFuelItem.display = `${quickbooksItem.Name} - ${quickbooksItem.Description} (${quickbooksItem.quickbooksItemId})`;
				quickbooksFuelItem.productDisplay = valueToDisplay(defaultForProductType);
			});
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12} md={12}>
					<Paper className={classes.paper}>
						<FMPHeadline label="Quickbooks Freight Accounts for Freight Bills" />
						<Grid container spacing={3} style={{ alignItems: 'center' }}>
							<Grid item md={12}>
								<div className={classes.infoBox}>
									These are the account options that show up in the selection list when filling out
									a freight vendor bill. If you select a fuel type for the default then when
									processing a fright bill and the po number matches a delivery it will use the fuel
									from that delivery to auto fill the account.
								</div>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Add new options'} isTop={true} />
							</Grid>

							<Grid item md={5}>
								<FMPQuickbooksAccountSelect
									{...this.getInputProps('quickbooksAccountId')}
									label="Quickbooks account to add"
								/>
							</Grid>

							<Grid item md={4}>
								<FMPProductSelect
									{...this.getInputProps(`defaultForProductType`)}
									productTypes={['none'].concat(_.map(allProducts, 'value'))}
									label={'Default for Fuel Type'}
									helpText={' '}
								/>
							</Grid>
							<Grid item md={3}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleAddFreight}
								>
									Add
								</Button>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Current Options'} />
							</Grid>
							<Grid item md={12}>
								{_.isEmpty(quickbooksFreightAccounts) && <div>Fetching freight mappings...</div>}

								{!_.isEmpty(quickbooksFreightAccounts) && (
									<div className={classes.currentOptions}>
										{_.sortBy(quickbooksFreightAccounts, 'display').map(
											(quickbooksFreightAccount) => {
												/** @namespace quickbooksFreightAccount.quickbooksFreightAccountId **/
												return (
													<div key={quickbooksFreightAccount.quickbooksFreightAccountId}>
														<strong>{quickbooksFreightAccount.display}</strong> -{' '}
														{quickbooksFreightAccount.productDisplay}
													</div>
												);
											}
										)}
									</div>
								)}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} md={12}></Grid>
				<Grid item xs={12} md={6}>
					<Paper className={classes.paper}>
						<FMPHeadline label="Quickbooks Fuel Items for Fuel Bills" />
						<Grid container spacing={3} style={{ alignItems: 'center' }}>
							<Grid item md={12}>
								<div className={classes.infoBox}>
									These are the item options when show up in the <strong>fuel</strong> selection
									list when filling out a fuel vendor bill.
								</div>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Add new options'} isTop={true} />
							</Grid>

							<Grid item md={5}>
								<FMPQuickbooksItemSelect
									{...this.getInputProps('quickbooksItemId')}
									label="Quickbooks item to add"
								/>
							</Grid>
							<Grid item md={5}>
								<FMPProductSelect
									{...this.getInputProps(`defaultForProductTypeForFuel`)}
									productTypes={['none'].concat(_.map(allProducts, 'value'))}
									label={'Default for Fuel Type'}
									helpText={' '}
								/>
							</Grid>
							<Grid item md={1}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleAddFuelItem}
								>
									Add
								</Button>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Current Fuel Options'} />
							</Grid>
							<Grid item md={12}>
								{_.isEmpty(quickbooksFuelItems) && <div>Fetching freight mappings...</div>}

								{!_.isEmpty(quickbooksFuelItems) && (
									<div className={classes.currentOptions}>
										{_.sortBy(quickbooksFuelItems, 'display').map((quickbooksFuelItem) => {
											const { quickbooksFuelItemId, isFuelLineItem, display } = quickbooksFuelItem;
											if (!isFuelLineItem) {
												return null;
											}

											/** @namespace quickbooksFuelItem.quickbooksFuelItemId **/
											return (
												<div key={quickbooksFuelItemId}>
													<strong>{display}</strong> / {quickbooksFuelItem.productDisplay}
												</div>
											);
										})}
									</div>
								)}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} md={6}>
					<Paper className={classes.paper}>
						<FMPHeadline label="Quickbooks Tax Items for Fuel Bills" />
						<Grid container spacing={3} style={{ alignItems: 'center' }}>
							<Grid item md={12}>
								<div className={classes.infoBox}>
									These are the item options that will show up in the
									<strong>tax</strong>selection list when filling out a fuel vendor bill.
								</div>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Add new options'} isTop={true} />
							</Grid>

							<Grid item md={5}>
								<FMPQuickbooksItemSelect
									{...this.getInputProps('quickbooksTaxItemId')}
									label="Quickbooks item to add"
								/>
							</Grid>

							<Grid item md={1}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleAddTaxItem}
								>
									Add
								</Button>
							</Grid>

							<Grid item md={12}>
								<FMPSectionHeader label={'Current Tax Options'} />
							</Grid>
							<Grid item md={12}>
								{_.isEmpty(quickbooksFuelItems) && <div>Fetching freight mappings...</div>}

								{!_.isEmpty(quickbooksFuelItems) && (
									<div className={classes.currentOptions}>
										{_.sortBy(quickbooksFuelItems, 'display').map((quickbooksFuelItem) => {
											const { quickbooksFuelItemId, isFuelLineItem, display } = quickbooksFuelItem;
											if (isFuelLineItem) {
												return null;
											}

											/** @namespace quickbooksFuelItem.quickbooksFuelItemId **/
											return (
												<div key={quickbooksFuelItemId}>
													<strong>{display}</strong>
												</div>
											);
										})}
									</div>
								)}
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

QuickbooksMapping.propTypes = {
	classes: PropTypes.object.isRequired,

	searchQuickbooksFreightAccounts: PropTypes.func.isRequired,
	addQuickbooksFreightAccount: PropTypes.func.isRequired,
	quickbooksFreightAccounts: PropTypes.array,
	quickbooksAccountMap: PropTypes.object,

	searchQuickbooksFuelItems: PropTypes.func.isRequired,
	addQuickbooksFuelItem: PropTypes.func.isRequired,
	quickbooksFuelItems: PropTypes.array,
	quickbooksItemMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	QuickbooksFreightAccountContainer,
	QuickbooksFuelItemContainer,
])(QuickbooksMapping);
